// ************************************ RECAPTCHA INFORMAÇÕES DE ACESSO ***************************

export const SITE_KEY = '6LcVfWMaAAAAAFA-nqum7z90qu6XJJUQo7OkAsNp';
export const SECRET_KEY = '6LcVfWMaAAAAACotI0eiSPuV_0-fjmtNr2-MfEPI';